import { dataWhirlpoolSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconWhirlpoolSolid = /*#__PURE__*/createIcon(dataWhirlpoolSolid)
export default IconWhirlpoolSolid
